import { RadioButton, Tooltip, Typography } from "@procore/core-react";
import React, { useEffect, useState } from "react";
import { useI18nContext } from "@procore/core-react";

export default function ScheduleChangesRadioButtons() {
   const I18n = useI18nContext();
   const [selectedOption, setSelectedOption] = useState("choose_end_date");

   useEffect(() => {
      const storedOption = localStorage.getItem("boards-schedule-changes");
      if (storedOption) {
         setSelectedOption(storedOption);
      }
   }, []);
   const handleChange = (value: string) => {
      setSelectedOption(value);
      localStorage.setItem("boards-schedule-changes", value);
   };

   // The spans are required around the RadioButtons to prevent the Tooltip from not being visible
   // https://core.procore.com/11.0.0/web/components/tooltip/react/#usage
   return (
      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
         <Typography intent="h3" style={{ fontSize: "14px" }}>
            {I18n.t("views.company.workforce_planning.boards.configure_panel.schedule_changes")}
         </Typography>
         <Typography intent="small">
            {I18n.t(
               "views.company.workforce_planning.boards.configure_panel.schedule_changes_description",
            )}
         </Typography>
         <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            <Tooltip
               overlay={I18n.t(
                  "views.company.workforce_planning.boards.configure_panel.assign_to_project_end_date_description",
               )}
            >
               <span>
                  <RadioButton
                     id="project_end_date"
                     name="schedule-changes"
                     value="project_end_date"
                     checked={selectedOption === "project_end_date"}
                     onChange={() => handleChange("project_end_date")}
                  >
                     {I18n.t(
                        "views.company.workforce_planning.boards.configure_panel.assign_to_project_end_date",
                     )}
                  </RadioButton>
               </span>
            </Tooltip>
            <Tooltip
               overlay={I18n.t(
                  "views.company.workforce_planning.boards.configure_panel.choose_end_date_description",
               )}
            >
               <span>
                  <RadioButton
                     id="choose_end_date"
                     name="schedule-changes"
                     value="choose_end_date"
                     checked={selectedOption === "choose_end_date"}
                     onChange={() => handleChange("choose_end_date")}
                  >
                     {I18n.t(
                        "views.company.workforce_planning.boards.configure_panel.choose_end_date",
                     )}
                  </RadioButton>
               </span>
            </Tooltip>
            <Tooltip
               overlay={I18n.t(
                  "views.company.workforce_planning.boards.configure_panel.single_day_description",
               )}
            >
               <span>
                  <RadioButton
                     id="single_day"
                     name="schedule-changes"
                     value="single_day"
                     checked={selectedOption === "single_day"}
                     onChange={() => handleChange("single_day")}
                  >
                     {I18n.t("views.company.workforce_planning.boards.configure_panel.single_day")}
                  </RadioButton>
               </span>
            </Tooltip>
         </div>
      </div>
   );
}
